export const INPUT_MANAGEMENT_NOM_WEEK_MODEL_LIST = 'INPUT_MANAGEMENT_NOM_WEEK_MODEL_LIST'
export const INPUT_MANAGEMENT_NOM_WEEK_SEARCH = 'INPUT_MANAGEMENT_NOM_WEEK_SEARCH'
export const INPUT_MANAGEMENT_NOM_WEEK_PAGINATION = 'INPUT_MANAGEMENT_NOM_WEEK_PAGINATION'
export const INPUT_MANAGEMENT_NOM_WEEK_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_NOM_WEEK_DROP_DOWN_SEARCH_TYPE'
